import React from "react";
import { Form } from "../../../components/Form";
import { Paragraph } from "../../../components/Text";
import { Select } from "../../../components/CustomSelect";
import { Input } from "../../../components/CustomInput";


const CancelVerificationForm = ({ onSubmit, onCancel, ...props}) => {
    const form = Form.useForm();
    const options = [
        { key: 1, title: "Verified pre-emptively, not yet to be released" },
        { key: 2, title: "Experimental package, not for public" },
        { key: 3, title: "Bug found, removing from public downloads" },
        { key: 4, title: "Error in Package creation found" },
        { key: 5, title: "New version is available" },
        { key: 0, title: "Other" }
    ];

    const onSubmitValues = (values={}) => {
        const { notes, notes2 } = values;
        onSubmit(notes2 ?? notes);
        onCancel();
    }

    return(<Form
        form={form}
        title="Cancel package verification"
        onCancel={onCancel}
        onSubmit={onSubmitValues}
    >
        <Paragraph style={{ marginBottom: "8px" }}>Please enter the reason you want to cancel the package verification:</Paragraph>
        <Form.Item name="notes" required>
            <Select
                bordered
                options={options}
            />
        </Form.Item>
        {form.watch("notes") == "Other"
            ? <Form.Item name="notes2" required>
                <Input.TextArea bordered maxLength={250} rows={5} />
            </Form.Item>
            : null}
    </Form>)
};

export { CancelVerificationForm };